import CouponCode from './coupon_code.vue';

export default CouponCode;
